function initCustomerReviews() {
  document.querySelectorAll(".customer-review-slider").forEach((slider) => {
    if (slider.dataset.initialized === "true") return;
    slider.dataset.initialized = "true";

    const slides = slider.querySelectorAll(".customer-review-slide");
    const dots = slider.parentElement.querySelectorAll(".review-dot");

    if (!slides.length) return;

    let current = 0;
    let timer = null;

    const autoplay = slider.dataset.autoplay === "true";
    const speed = (parseInt(slider.dataset.speed) || 5) * 1000;

    function showSlide(index) {
      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }

      current = index;

      slides.forEach((slide, i) => {
        slide.classList.toggle("active", i === current);
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === current);
      });
    }

    function nextSlide() {
        const currentSlide = slides[current];
        const stack = currentSlide.querySelector(".polaroid-stack");

        if (!stack) {
          showSlide(current + 1);
          return;
        }

        stack.classList.add("stack-animate");

        setTimeout(() => {
          showSlide(current + 1);
          stack.classList.remove("stack-animate");
        }, 350); // Match your CSS transition duration
      }

    function startAutoplay() {
      if (!autoplay || slides.length <= 1) return;

      stopAutoplay();

      timer = setInterval(() => {
        nextSlide();
      }, speed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        showSlide(index);
        startAutoplay();
      });
    });

    slider.addEventListener("mouseenter", stopAutoplay);
    slider.addEventListener("mouseleave", startAutoplay);

    let touchStartX = 0;
    let touchEndX = 0;

    slider.addEventListener(
      "touchstart",
      (e) => {
        touchStartX = e.changedTouches[0].clientX;
      },
      { passive: true }
    );

    slider.addEventListener(
      "touchend",
      (e) => {
        touchEndX = e.changedTouches[0].clientX;

        const distance = touchStartX - touchEndX;

        if (Math.abs(distance) < 50) return;

        if (distance > 0) {
          nextSlide();
        } else {
          showSlide(current - 1);
        }

        startAutoplay();
      },
      { passive: true }
    );

    slides.forEach((slide) => {
      const imageContainer = slide.querySelector('.polaroid-stack');
      if (imageContainer) {
        imageContainer.addEventListener('click', () => {
          nextSlide();
          startAutoplay();
        });
      }
    });

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    showSlide(0);
    startAutoplay();
  });
}

if (document.readyState !== 'loading') {
  initCustomerReviews();
} else {
  document.addEventListener('DOMContentLoaded', initCustomerReviews);
}

